import HSApi from '../../HSApi';
import { ProtocolListResult } from './protocol-list.result';

export async function getProtocolList(page = 0, size = 20, order: null | string): Promise<ProtocolListResult> {
  const res = await HSApi.get<ProtocolListResult>(`/physician-protocols/views?page=${page}&size=${size}&order=${order ?? ''}`);

  return res.data;
}
export async function exportProtocolList() {

  const res = await HSApi.get(`/physician-protocols/views/export?type=EXCEL`, { responseType: 'blob' });
  const file = res.data;
  const url = URL.createObjectURL(file);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'protokol-defteri.xlsx';
  a.click();
}
